module.exports = __webpack_public_path__ + "img/perforaciones_3-4_768.b591cb20.jpg";